// This file is overwritten at release time by copypackageversion.js
export const oteljsVersion = 'dev';
